import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
export const Button = ()=>{
    return /*#__PURE__*/ _jsx("button", {
        children: "Solvook Boop"
    });
};
